import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { KindeProvider } from "@kinde-oss/kinde-auth-react";

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <KindeProvider
      clientId="d7477dff10c34b64be0833b9b4885b4a"
      domain="https://axion.kinde.com"
      redirectUri={window.location.origin}
      logoutUri={window.location.origin}
    >
      <App />
    </KindeProvider>
  </React.StrictMode>
);